import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MemberService } from '@app/services/member.service';
import { Sort } from '@angular/material/sort';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { MenuItem, SelectItem, MessageService } from 'primeng/api';
import { DatePipe } from '@angular/common';
import { CSVDataService } from '@app/export/CSVDataService';
import { MailService } from '@app/services/shared/mail.service';
import { NavigationEnd, Router } from '@angular/router';
import { PermissionsService } from '@app/services/permissions/permissions.service';

interface SignType {
  id: number;
  name: string;
}

interface Sign {
  id: number;
  abbreviation: string;
  name: string;
  type: number;
  sort: number;
}

@Component({
  selector: 'app-signreport',
  templateUrl: './signreport.component.html',
  styleUrls: ['./signreport.component.css']
})
export class SignreportComponent implements OnInit {
  signreportform;
  
  items: MenuItem[];
  expanded = true;
  expandedlabel = 'Stäng grupper';
  signtypelist: SignType[] = [];
  signlist: Sign[] = [];
  notsignlist: Sign[] = [];
  membershipselectedinstitutions: any[] = [];
  nomembershipselectedinstitutions: any[] = [];
  selectedsigninstitutions: any[] = [];
  emaillist: any[] = [];
  se: any;
  result;
  someorall: SelectItem[];
  epost: SelectItem[];
  displayMembership = false;
  displayNoMembership = false;
  displayInstitutions = false;
  access;
  selectedrole;
  /************* Dateformat ****************************************/
  // maxYear ska sättas dynamiskt.
  minmaxyear = { minYear: '1920', maxYear: '2030' };
  autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy-mm-dd', this.minmaxyear);
  public mask = [/[1-9]/, /\d/, /\d/, ' ', /\d/, /\d/]; // zipcode
  public maskdatum = [/[129]/, /[?09]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
  to: any[] = [];
  emailaddresses: any[] = [];
  selectedmembers: any[] = [];
  showMailView = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private permissionService: PermissionsService,
    private memberService: MemberService,
    private datePipe: DatePipe,
    private messageService: MessageService) {
    this.router.events.subscribe(x => {
      if (x instanceof NavigationEnd) {
        this.clear();
      }
    });
    this.someorall = [{ label: 'både', value: 'all' }, { label: 'någon av', value: 'some' }];
    this.epost = [{ label: 'Ja', value: 'yes' }, { label: 'Nej', value: 'no' }, { label: 'Båda', value: 'both' }];
  }

  ngOnInit() {
    this.signreportform = this.fb.group({
      signTypeId: ['', ''],
      notSignTypeId: ['', ''],
      signId: ['', ''],
      notSignId: ['', ''],
      signInstitutions: ['', ''],
      signPeriodFrom: ['', ''],
      signPeriodTo: ['', ''],
      email1: ['both', ''],
      email2: ['both', ''],
      membershipSomeOrAll: ['some', ''],
      membershipInstitutions: ['', ''],
      membershipStartedFrom: ['', ''],
      membershipStartedTo: ['', ''],
      membershipEndedFrom: ['', ''],
      membershipEndedTo: ['', ''],
      nomembershipSomeOrAll: ['some', ''],
      nomembershipInstitutions: ['', ''],
      nomembershipStartedFrom: ['', ''],
      nomembershipStartedTo: ['', ''],
      nomembershipEndedFrom: ['', ''],
      nomembershipEndedTo: ['', ''],
      parentInstitutionId: ['', ''],
      institutionId: ['', ''],
      institutionTypeId: ['','']
    });
    
    this.permissionService.access.subscribe(a => {
      if (a) {
        this.access = a;
      }
    });

    this.permissionService.selectedrole.subscribe(r => {
      if (r) {
        this.selectedrole = r;
      }
    });

    this.se = {
      firstDayOfWeek: 1,
      dayNames: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
      dayNamesShort: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
      dayNamesMin: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
      // tslint:disable-next-line: max-line-length
      monthNames: ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
      monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      today: 'I dag',
      clear: 'Rensa',
      dateFormat: 'yy-mm-dd',
      weekHeader: 'Vecka'
    };
    this.getSignTypes();
    this.getSigns();
    this.setItems();
  }

  setItems() {
    this.items = [
      {
        label: 'Excel',
        icon: 'fa fa-file-excel',
        command: () => this.exportToCSV()
      }, {
        label: 'Epost',
        icon: 'fa fa-envelope',
        command: () => this.sendMail(),
        visible: this.selectedmembers?.length > 0 && this.selectedrole.permissions.includes('SEND_EMAIL')
      }, {
        label: 'Etiketter',
        icon: 'fa fa-id-card',
        visible: this.selectedmembers?.length > 0 && this.selectedrole.permissions.includes('VIEW_POSTALS'),
        command: () => this.createLabels()
      }];
  }

  createLabels() {
    let idlista: any[] = [];
    if (this.selectedmembers?.length > 0) {
      this.selectedmembers.forEach(x => {
        idlista.push(x.memberId);
      });
    } else {
      this.result.forEach(x => {
        idlista.push(x.memberId);
      });
    }
    this.memberService.GetMemberInfoFromMemberIds(idlista).subscribe(x => {
      if (x) {
        let memberlista: any[] = [];
        x.forEach(i => {
          const data = {
            givenName: i.givenName + ' ' + i.familyName,
            street: i.street,
            zipCode: i.zipCode,
            homeCity: i.homeCity,
            homeCountry: i.homeCountry
          };
          memberlista.push(data);
        });
        const firstrow = 'Namn;Gatuadress;Postnummer;Ort;Land';
        const filnamn = 'OF_Etikettdata_Utmärkelser_medlemmar';
        CSVDataService.exportToCsv(filnamn + '.csv', memberlista, firstrow);
      }
    });
  }

  sendMail() {
    this.selectedmembers.forEach(m => {
      m['id'] = m.memberId;
    });
    this.showMailView = true;
  }

  getSignsBySignType(evt, list) {
    if (Number(evt.target.value) !== 0) {
      this.memberService.getSignsBySignType(Number(evt.target.value)).subscribe(resp => {
        switch (list) {
          case 'signlist': this.signlist = resp;
            break;
          case 'notsignlist': this.notsignlist = resp;
            break;
        }

      });
    } else {
      this.getSigns();
    }
  }


  getSignTypes() {
    this.memberService.getSignTypes().subscribe(response => {
      this.signtypelist = response;
    });
  }

  getSigns() {
    this.memberService.getSigns().subscribe(response => {
      if (response) {
        this.signlist = response;
        this.notsignlist = this.signlist;
      }
    });
  }

  removeMembershipSelectedInstitution(id: number) {
    const idx = this.membershipselectedinstitutions.findIndex(x => x.id === id);
    this.membershipselectedinstitutions.splice(idx, 1);
  }

  removeNoMembershipSelectedInstitution(id: number) {
    const idx = this.nomembershipselectedinstitutions.findIndex(x => x.id === id);
    this.nomembershipselectedinstitutions.splice(idx, 1);
  }

  removeSelectedSignInstitution(id: number) {
    const idx = this.selectedsigninstitutions.findIndex(x => x.id === id);
    this.selectedsigninstitutions.splice(idx, 1);
  }

  setDate(first, second) {
    const datum = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.signreportform.get(first).patchValue(datum);
    this.signreportform.get(second).patchValue(datum);
  }

  search() {
    const signinstitutions: any[] = [];
    this.selectedsigninstitutions.forEach(i => {
      signinstitutions.push(i.id);
    });

    const membershipinstitutions: any[] = [];
    this.membershipselectedinstitutions.forEach(i => {
      membershipinstitutions.push(i.id);
    });

    const nomembershipinstitutions: any[] = [];
    this.nomembershipselectedinstitutions.forEach(i => {
      nomembershipinstitutions.push(i.id);
    });

    this.signreportform.get('signInstitutions').patchValue(signinstitutions);
    this.signreportform.get('membershipInstitutions').patchValue(membershipinstitutions);
    this.signreportform.get('nomembershipInstitutions').patchValue(nomembershipinstitutions);
    this.memberService.GetSignReport(this.signreportform.value).subscribe(response => {
      this.result = response.item2;
      if (response.item1 == '') {
        this.setItems();
      } else {
        this.messageService.add({ severity: 'warn', summary: 'Information', detail: response.item1 });
      }
    });
  }

  exportToCSV() {
    console.log('Result: ', this.result);
    this.result.forEach(x => {
      x.date = this.datePipe.transform(x.date, 'yyyy-MM-dd');
    });
    // tslint:disable-next-line:max-line-length
    const firstrow = "Medlemsnummer;Förnamn;Övriga Förnamn;Mellannamn;Efternamn;Tidigare Efternamn;Yrke/Titel;Bostad C/O;Bostad Gata/Box;Bostad Postnummer;Bostad Ort;Bostad Land;Arbete C/O;Arbete Gata/Box;Arbete Postnummer;Arbete Ort;Arbete Land;Annan C/O;Annan Gata/Box;Annan Postnummer;Annan Ort;Annan Land;Telefon 1;Telefon 2;Arbetstelefon;Mobiltelefon;Fax;E-post 1;E-post 2;Hemsida;Invigd datum;Medlemsnummer Fadder;Fadder;Födelsedatum;SOFT - (J/N);Lokalt medlemsnummer;Primärinstitution;Institution.Förkortning;Institution.Namn;Institution.Ort;Institution.Land;Utmärkelse.Förkortning;Utmärkelse.Namn;Utmärkelse.Typ;Datum";
    const datum = this.datePipe.transform(new Date(), 'yyMMdd');
    const filnamn = 'Utmärkelser_' + datum;
    let data;
    let dataset: any[] = [];
    this.result.forEach(x => {
      data = {
        memberId: x.memberInfo.id,
        givenName: x.memberInfo.givenName,
        otherForeNames: x.memberInfo.otherForeNames,
        middleName: x.memberInfo.middleName,
        familyName: x.memberInfo.familyName,
        formerName: x.memberInfo.formerName,
        title: x.memberInfo.title,
        careOf: x.memberInfo.h_CareOf,
        street: x.memberInfo.h_Street,
        zipCode: x.memberInfo.h_ZipCode,
        city: x.memberInfo.h_City,
        country: x.memberInfo.h_Country,
        workAddress_careOf: x.memberInfo.w_CareOf,
        workAddress_street: x.workAddress?.w_Street,
        workAddress_zipCode: x.workAddress?.w_ZipCode,
        workAddress_city: x.workAddress?.w_City,
        workAddress_country: x.workAddress?.w_Country,
        otherAddress_careOf: x.workAddress?.o_CareOf,
        otherAddress_street: x.workAddress?.o_Street,
        otherAddress_zipCode: x.memberInfo.o_ZipCode,
        otherAddress_city: x.memberInfo.o_City,
        otherAddress_country: x.memberInfo.h_Country,
        phone1: x.memberInfo.phone ? x.memberInfo.phone + String.fromCharCode(8203) : '',
        phone2: x.memberInfo.phone2 ? x.memberInfo.phone2 + String.fromCharCode(8203) : '',
        phoneWork: x.memberInfo.phoneWork ? x.memberInfo.phoneWork + String.fromCharCode(8203) : '',
        phoneMobile: x.memberInfo.phoneMobile ? x.memberInfo.phoneMobile + String.fromCharCode(8203) : '',
        fax: x.memberInfo.fax ? x.memberInfo.fax + String.fromCharCode(8203) : '',
        email1: x.memberInfo.email1,
        email2: x.memberInfo.email2,
        webSite: x.memberInfo.webSite,
        initiationDate: this.datePipe.transform(x.memberInfo.initiationDate, 'yyyy-MM-dd'),
        mentorMemberId: x.memberInfo.mentor ? x.memberInfo.mentor.memberId : '',
        mentorGivenName: x.memberInfo.mentor?.givenName ? x.memberInfo.mentor?.givenName + ' ' + x.memberInfo.mentor?.familyName : '',
        birthday: this.datePipe.transform(x.memberInfo.birthday, 'yyyy-MM-dd'),
        isSOFTSubscriber: x.memberInfo.isSubscriber ? 'Ja' : 'Nej',
        localId: x.memberInfo.localId,
        primaryInstitution: x.memberInfo.primaryInstitution.shortName + ' ' + x.memberInfo.primaryInstitution.name,
        institutionShortName: x.institutionShortName,
        institutionName: x.insitutionName,
        institutionSeat: x.institutionSeat,
        institutionCountry: x.institutionCountry,
        signAbbreviation: x.signAbbreviation,
        signName: x.signName,
        signTypeName: x.signTypeName,
        date: x.date
      }
      dataset.push(data);
    });
    CSVDataService.exportToCsv(filnamn + '.csv', dataset, firstrow);
  }

  clear() {
    this.signreportform?.reset();
    this.signreportform?.get('email1').setValue('both');
    this.signreportform?.get('email2').setValue('both');
    this.result = [];
    this.selectedsigninstitutions = [];
    this.membershipselectedinstitutions = [];
    this.nomembershipselectedinstitutions = [];
  }

  sortData(sort: Sort) {
    const data = this.result.slice();
    if (!sort.active || sort.direction === '') {
      this.result = data;
      return;
    }

    this.result = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'memberId': return this.compare(a.memberInfo.id, b.memberInfo.id, isAsc);
        case 'givenName': return this.compare(a.memberInfo.givenName, b.memberInfo.givenName, isAsc);
        case 'familyName': return this.compare(a.memberInfo.familyName, b.memberInfo.familyName, isAsc);
        case 'institutionShortName': return this.compare(a.institutionShortName, b.institutionShortName, isAsc);
        case 'institutionName': return this.compare(a.insitutionName, b.insitutionName, isAsc);
        case 'institutionSeat': return this.compare(a.institutionSeat, b.institutionSeat, isAsc);
        case 'signName': return this.compare(a.signName, b.signName, isAsc);
        case 'signTypeName': return this.compare(a.signTypeName, b.signTypeName, isAsc);
        case 'date': return this.compare(a.date, b.date, isAsc);
        default: return 0;
      }
    });
  }

  compare(a: number | string | Date | boolean, b: number | string | Date | boolean, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  setSelectedInstitutions(evt, institutionlist) {
    switch (institutionlist) {
      case 'membership': this.membershipselectedinstitutions = evt;
        break;
      case 'nomembership': this.nomembershipselectedinstitutions = evt;
        break;
      case 'sign': this.selectedsigninstitutions = evt;
        break;
    }
  }

  checkMember(memberid: number) {
    return this.selectedmembers.find(item => item.id === memberid);
  }

 /* add(member, element) {
    if (element.checked) {
      if (!this.checkMember(member.memberId)) {
        this.selectedmembers.push(member);
        const idx = this.result.findIndex(m => m.memberId === Number(member.memberId));
        this.result[idx].checked = true;
      }
    } else {
      this.removeFromArray(member.memberId);
    }
    this.setItems();
  }*/

  add(member, element) {
    if (element.checked) {
      if (!this.checkMember(member.memberInfo.id)) {
       member.id = member.memberInfo.id;
       member.givenName = member.memberInfo.givenName;
       member.familyName = member.memberInfo.familyName;
        this.selectedmembers.push(member);
        const idx = this.result.findIndex(m => {
          m.memberId = m.memberInfo.id;
          m.email1 = m.memberInfo.email1;
          m.memberInfo.id === member.memberInfo.id;
        });
        if(idx!==-1) {
        this.result[idx].checked = true;
        }
      }
    } else {
      this.removeFromArray(member.memberInfo.id);
    }
    this.setItems();
  }

  removeFromArray(id: number) {
    const idx = this.selectedmembers.findIndex(item => item.id === id);
    this.selectedmembers.splice(idx, 1);
    const index = this.result.findIndex(m => m.id === id);
    if (index !== -1) {
      this.result[index].checked = false;
    }
  }

  checkuncheckAll(element) {
    let value = false;
    element.checked ? value = true : value = false;
    for (const m of this.result) {
      if (m.primaryInstitution !== 'AV1') {
        m.checked = value;
        this.add(m, element);
      }
    }
  }

  closeEmail(evt: any) {
    this.showMailView = false;
    this.setItems();
    this.selectedmembers = [];
  }
}
